import React from 'react'
import PropTypes from 'prop-types';
import { Form, Input, Button, Icon, Switch } from 'antd'

const FormItem = Form.Item

let fieldId = {};

class OtherSettings extends React.Component {
    state = {

    }

    onButtonTypeChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    }

    remove = (field, k) => {
       const { form } = this.props;
       field += 'Keys'
       // can use data-binding to get
       const keys = form.getFieldValue(field);
       // We need at least one passenger
       if (keys.length === 1) {
         return;
       }

       // can use data-binding to set
       form.setFieldsValue({
         [field]: keys.filter(key => key !== k),
       });
    }

    add = (field) => {
       const { form } = this.props;
       field += 'Keys'

       // can use data-binding to get
       const keys = form.getFieldValue(field);

       if (!fieldId[field]) {
           fieldId[field] = 1;
       }
       const nextKeys = keys.concat(fieldId[field]++);

       // can use data-binding to set
       // important! notify form to detect changes
       form.setFieldsValue({
         [field]: nextKeys,
       });
    }

    render() {

        const { form, excludePaths, ignoreClasses, autoRedirect } = this.props
        const {  getFieldDecorator, getFieldValue } = form

        const formItemLayoutWithOutLabel = {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 12, offset: 4 },
          },
        };

        getFieldDecorator('excludePathsKeys', { initialValue: excludePaths && excludePaths.length > 0 ? Object.keys(excludePaths) : [0] });

        //const styleFloatRight = { stlyle : { float: 'right'}}
        const excludePathsKeys = getFieldValue('excludePathsKeys');
        const excludePathsItems = excludePathsKeys.map((k, index) => (
          <Form.Item
            {...(index === 0 ? {} : formItemLayoutWithOutLabel)}
            label={index === 0 ? 'Exclude Paths' : ''}
            required={false}
            key={k}
          >
            {getFieldDecorator(`excludePaths[${k}]`, {
              initialValue : excludePaths[k],
              validateTrigger: ['onChange', 'onBlur'],
              rules: [{
                whitespace: true,
              }],
            })(
              <Input style={{ width: '95%'}} />
            )}
            {excludePathsKeys.length > 1 ? (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                disabled={excludePathsKeys.length === 1}
                onClick={() => this.remove("excludePaths", k)}
              />
            ) : null}
          </Form.Item>
        ));

        getFieldDecorator('ignoreClassesKeys', { initialValue: ignoreClasses && ignoreClasses.length > 0 ? Object.keys(ignoreClasses) : [0] });

        const ignoreClassesKeys = getFieldValue('ignoreClassesKeys');
        const ignoreClassesItems = ignoreClassesKeys.map((k, index) => (
          <Form.Item
            {...(index === 0 ? {} : formItemLayoutWithOutLabel)}
            label={index === 0 ? 'Ignore Classes' : ''}
            required={false}
            key={k}
          >
            {getFieldDecorator(`ignoreClasses[${k}]`, {
              initialValue : ignoreClasses[k],
              validateTrigger: ['onChange', 'onBlur'],
              rules: [{
                whitespace: true,
              }],
            })(
              <Input style={{ width: '95%'}} />
            )}
            {ignoreClassesKeys.length > 1 ? (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                disabled={ignoreClassesKeys.length === 1}
                onClick={() => this.remove("ignoreClasses", k)}
              />
            ) : null}
          </Form.Item>
        ));
        return (
            <div id="#tl-other-settings">
                <div>

                  <FormItem label="Auto Redirect" extra="Automatically display the translated page based on the user's browser language">
                    {form.getFieldDecorator('autoRedirect', {
                        initialValue:  autoRedirect,
                        valuePropName: 'checked'
                    })(<Switch size="default" />)}
                  </FormItem>

                   {excludePathsItems}

                    <Form.Item {...formItemLayoutWithOutLabel}>
                      <Button type="dashed" onClick={() => {this.add("excludePaths")}}>
                        <Icon type="plus" /> Add More
                      </Button>
                    </Form.Item>

                    {ignoreClassesItems}

                    <Form.Item {...formItemLayoutWithOutLabel}>
                      <Button type="dashed" onClick={() => {this.add("ignoreClasses")}}>
                        <Icon type="plus" /> Add More
                      </Button>
                    </Form.Item>

                </div>

            </div>
        )
    }
}

OtherSettings.propTypes = {
  autoRedirect: PropTypes.bool,
  excludePaths: PropTypes.arrayOf(PropTypes.string),
  ignoreClasses: PropTypes.arrayOf(PropTypes.string),
}

OtherSettings.defaultProps = {
  autoRedirect: false,
  excludePaths: [],
  ignoreClasses: [],
}

export default OtherSettings
